<template>
  <div v-html="content"></div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ShowArticle',
  data() {
    return {
      article: '',
      content: '<h2>Article is not loading.</h2>'
    };
  },
  beforeRouteEnter(to, from, next) {
    if (!to.params.articleId) {
      axios
        .get(
          process.env.VUE_APP_BASE_URL +
            '/' +
            to.params.productId +
            '/' +
            to.params.appId +
            '/' +
            to.params.sectionId +
            '/noArticleUrl'
        )
        .then(response => {
          next(
            '/' +
              to.params.productId +
              '/' +
              to.params.appId +
              '/' +
              to.params.sectionId +
              '/' +
              response.data
          );

          next(vm => {
            vm.setData(response);
          });
        })
        .catch(function (error) {
          if (error) {
            next({ path: '/404' })
          }
        });
    } else {
      axios
        .get(
          process.env.VUE_APP_BASE_URL +
            '/' +
            to.params.productId +
            '/' +
            to.params.appId +
            '/' +
            to.params.sectionId +
            '/' +
            to.params.articleId
        )
        .then(response => {
          next(vm => {
            vm.setData(response);
          });
        });
    }
  },
  beforeRouteUpdate(to, from, next) {
    next();
    axios
      .get(
        process.env.VUE_APP_BASE_URL +
          '/' +
          to.params.productId +
          '/' +
          to.params.appId +
          '/' +
          to.params.sectionId +
          '/' +
          to.params.articleId
      )
      .then(response => {
        this.setData(response);
        next();
      });
  },
  methods: {
    setData(article) {
      this.content = article.data.content;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ql-container {
  height: 600px;
}
#editor {
  height: 375px;
}
.custom-btn {
  width: 120px;
  margin-left: auto;
}
.controls {
  width: 100%;
  text-align: right;
  padding-top: 20px;
}

.ql-container img,
#articleView img {
  max-width: 100% !important;
}
</style>
